<script lang="ts" setup>
import { type PropType, computed } from 'vue'

const props = defineProps({
    amountToSave: {
        type: Number,
        required: true
    },
    size: {
        type: String as PropType<'small' | 'large'>,
        default: 'large',
        validator(value: string) {
            return ['small', 'large'].includes(value)
        }
    }
})

defineEmits(['redirect'])

const isLarge = computed(() => props.size === 'large')
</script>

<template>
    <div
        class="cursor-pointer w-full h-fit flex justify-start items-center rounded-lg bg-primary-light"
        :class="isLarge ? 'gap-4 p-4' : 'gap-2 p-2'"
        @click="$emit('redirect')"
    >
        <IconChargemapBoost
            isSolid
            class="text-icon-secondary-accent size-5"
            :class="isLarge ? 'size-8' : 'size-5'"
        />
        <i18n-t
            keypath="boost.cta_banner.text"
            tag="p"
            for="boost.cta_banner.text"
        >
            <template #amount>
                <span class="text-secondary-accent-1 font-bold">
                    {{ $n(props.amountToSave, 'currency') }}
                </span>
            </template>
            <template #boost>
                <span class="text-secondary-accent-1 font-bold">
                    {{ $t('boost.cta_banner.boost') }}
                </span>
            </template>
        </i18n-t>
        <IconChevronRight
            class="text-icon-secondary-accent ml-auto size-5"
            :class="isLarge ? 'size-6' : 'size-4'"
        />
    </div>
</template>
